<div id="main-wrapper" style="margin-bottom: 40px;">
  <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '14px',fullScreenBackdrop:true }"></ngx-loading>
  <div class="container-fluid" style="padding: 0;">
    <app-header (found)="handleResults($event)"></app-header>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a routerLink="/providerportal" href="#" style="color: #23499E;">Providerportal</a></li>
        <li class="breadcrumb-item"><a routerLink="/providerportal/site_Administration" href="#" style="color: #23499E;">Site
        Administration</a></li>
        <li class="breadcrumb-item active" style="font-family: Myriad Pro" aria-current="page">View & Authenticate</li>
      </ol>
    </nav>
    <div class="row col-md-12 userAuthContainer">
      <div class="col-md-1 col-xs-2"></div>
      <div class="col-md-10 col-xs-12">
        <div class="col-md-12 faqMsg userAthmsg">
          <app-search-results [resultGridList]="data"></app-search-results>
          <tabset>
            <tab heading="New Users" (click)="checkTab='newUser'">
              @if (users !== undefined) {
                <div class="accordion" id="accordionnewUser" >
                  @for (user of users['0'] | sort :'firstName'; track user; let i = $index) {
                    <div class="accordion-item panel-default"  >
                      <h2 class="accordion-header" [attr.id]="'heading'+i">
                        <button class="accordion-button collapsed custom-accordion-button" type="button"  data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse'+i" aria-expanded="false" [attr.aria-controls]="'collapse'+i">
                          <span> {{user.firstName}} {{user.middleName}} {{user.lastName}} ({{user.userName}})</span>
                        </button>
                      </h2>
                      <div [attr.id]="'collapse'+i" class="accordion-collapse collapse" [attr.aria-labelledby]="'heading'+i" data-bs-parent="#accordionnewUser">
                        <div class="accordion-body">
                          <div class="row textFont">
                            <div class="col-md-2 col-xs-6 labelValue">
                              <b>User Name:</b>
                            </div>
                            <div class="col-md-2 col-xs-6 labelValue">
                              {{user.userName}}
                            </div>
                            <div class="col-md-2 col-xs-6 labelValue">
                              <b>NPI: </b>
                            </div>
                            <div class="col-md-2 col-xs-6 labelValue">
                              {{ (!user.npi || user.npi === '' || user.npi === 'null') ? '-' : [user.npi]}}
                            </div>
                            <div class="col-md-2 col-xs-6 labelValue">
                              <b> Tax ID: </b>
                            </div>
                            <div class="col-md-2 col-xs-6 labelValue">
                              {{ (!user.taxId || user.taxId === '' || user.taxId === 'null') ? '-' : [user.taxId]}}
                            </div>
                            <div class="col-md-2 col-xs-6 labelValue">
                              <b>Phone: </b>
                            </div>
                            <div class="col-md-2 col-xs-6 labelValue">
                              {{user.phone}}
                            </div>
                            <div class="col-md-2 col-xs-6 labelValue">
                              <b>Ext.: </b>
                            </div>
                            <div class="col-md-2 col-xs-6 labelValue">
                              {{ (!user.extn || user.extn === '' || user.extn === 'null') ? '-' : [user.extn]}}
                            </div>
                            <div class="col-md-2 col-xs-6 labelValue">
                              <b>Fax:</b>
                            </div>
                            <div class="col-md-2 col-xs-6 labelValue">
                              {{ (!user.fax || user.fax === '' || user.fax === 'null') ? '-' : [user.fax]}}
                            </div>
                            <div class="col-md-2 col-xs-6 labelValue">
                              <b> User Type: </b>
                            </div>
                            <div class="col-md-10 col-xs-6 labelValue">
                              {{user.regTypeDesc}}
                            </div>
                            <div class="col-md-2 col-xs-6 labelValue">
                              <b>Email:</b>
                            </div>
                            <div class="col-md-10 col-xs-6 labelValue">
                              {{ (!user.email || user.email === 'none@null.com' || user.email === 'null') ? '-' :
                              [user.email]}}
                            </div>
                            <div class="col-md-2 col-xs-6 labelValue">
                              <b>Address:</b>
                            </div>
                            <div class="col-md-10 col-xs-6 labelValue">
                              {{user.addressLine1}} {{user.addressLine2}} {{user.city}} {{user.state}} {{user.zip}}
                            </div>
                          </div>
                          <br>
                            <div class="form-check" style="padding-left: 0px;">
                              <input type="checkbox" style="padding: 0px;" class="form-check-input" id="exampleCheck1" [(ngModel)]="user.isAdmin">
                              <label class="form-check-label" for="exampleCheck1">Give account operator access</label>
                            </div>
                            <br>
                              <div class="row">
                                <div class="col-md-12 text-center btn-block">
                                  <button (click)="updateStatus(user, '1',false)" class="btn btn-primary carelon-primary-btn">Activate</button>
                                  <button (click)="updateStatus(user, '2',false)" style="margin-left:20px;" class="btn carelon-secondary-btn">Deactivate</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }

                </tab>
                <tab heading="Active Users" (click)="checkTab='activeUser'">
                  @if (activeUsers?.length) {
                    <div class="accordion" id="accordionactiveUser">
                      @for (user of activeUsers; track user; let i = $index) {
                        <div class="accordion-item panel-default"  >
                          <h2 class="accordion-header" [attr.id]="'heading'+i">
                            <button class="accordion-button collapsed custom-accordion-button" (click)="activeUserOpen(user)" type="button"   data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse'+i" aria-expanded="false" [attr.aria-controls]="'collapse'+i">
                              <span> {{user?.name}} ({{user?.userId}})</span>
                            </button>
                          </h2>
                          <div [attr.id]="'collapse'+i" class="accordion-collapse collapse" [attr.aria-labelledby]="'heading'+i" data-bs-parent="#accordionactiveUser">
                            <div class="accordion-body">
                              <div class="row textFont">
                                <div class="col-md-2 col-xs-6 labelValue">
                                  <b>User Name:</b>
                                </div>
                                <div class="col-md-2 col-xs-6 labelValue">
                                  {{user?.userName}}
                                </div>
                                <div class="col-md-2 col-xs-6 labelValue">
                                  <b>NPI: </b>
                                </div>
                                <div class="col-md-2 col-xs-6 labelValue">
                                  {{ (!user?.npi || user?.npi === '' || user?.npi === 'null') ? '-' : [user?.npi]}}
                                </div>
                                <div class="col-md-2 col-xs-6 labelValue">
                                  <b> Tax ID: </b>
                                </div>
                                <div class="col-md-2 col-xs-6 labelValue">
                                  {{ (!user?.taxId || user?.taxId === '' || user?.taxId === 'null') ? '-' : [user?.taxId]}}
                                </div>
                                <div class="col-md-2 col-xs-6 labelValue">
                                  <b>Phone: </b>
                                </div>
                                <div class="col-md-2 col-xs-6 labelValue">
                                  {{user?.phone}}
                                </div>
                                <div class="col-md-2 col-xs-6 labelValue">
                                  <b>Ext.: </b>
                                </div>
                                <div class="col-md-2 col-xs-6 labelValue">
                                  {{ (!user?.extn || user?.extn === '' || user?.extn === 'null') ? '-' : [user?.extn]}}
                                </div>
                                <div class="col-md-2 col-xs-6 labelValue">
                                  <b>Fax:</b>
                                </div>
                                <div class="col-md-2 col-xs-6 labelValue">
                                  {{ (!user?.fax || user?.fax === '' || user?.fax === 'null') ? '-' : [user?.fax]}}
                                </div>
                                <div class="col-md-2 col-xs-6 labelValue">
                                  <b> User Type: </b>
                                </div>
                                <div class="col-md-10 col-xs-6 labelValue">
                                  {{user?.regTypeDesc}}
                                </div>
                                <div class="col-md-2 col-xs-6 labelValue">
                                  <b>Email:</b>
                                </div>
                                <div class="col-md-10 col-xs-6 labelValue">
                                  {{ (!user?.email || user?.email === 'none@null.com' || user?.email === 'null') ? '-' :
                                  [user?.email]}}
                                </div>
                                <div class="col-md-2 col-xs-6 labelValue">
                                  <b>Address:</b>
                                </div>
                                <div class="col-md-10 col-xs-6 labelValue">
                                  {{user?.addressLine1}} {{user?.addressLine2}} {{user?.city}} {{user?.state}} {{user?.zip}}
                                </div>
                                <div class="col-md-2 col-xs-6 labelValue">
                                  <b>Sites:</b>
                                </div>
                                @if (selectedAllUserSites[user?.userId]) {
                                  <div class="col-md-10 col-xs-6 labelValue">
                                    @for (sites of selectedAllUserSites[user.userId]; track sites; let index = $index) {
                                      <span class="px-1">{{sites.siteName}} @if (index != selectedAllUserSites[user?.userId].length-1) {
                                        ,
                                      }</span>
                                    }
                                  </div>
                                }
                              </div>
                              <br>
                                <div class="row adminAccess">
                                </div>
                                @if (user?.status === 3) {
                                  <div class="row">
                                    <p style="color:red; margin-left: 15px;"><b>Note:</b> This user account is locked</p>
                                  </div>
                                }
                                <div class="row adminAccess btn-block">
                                  @if (user?.status === 3) {
                                    <button (click)="unlockUser(user)" class="btn btn-primary carelon-primary-btn">
                                      <span>Unlock</span>
                                    </button>
                                  }
                                </div>
                                <div class="row">
                                  <div class="col-md-12 text-center btn-block">
                                    @if ((user?.userRole !== 'Admin' || user?.userRole == 'null')) {
                                      <button (click)="user['isAdmin'] = (!user['isAdmin']); updateStatus(user, user?.status)"
                                        class="btn btn-primary carelon-primary-btn">
                                        <span> Give account operator access</span>
                                      </button>
                                    }
                                    @if (user?.userRole === 'Admin') {
                                      <button (click)="user['isAdmin'] = (!user['isAdmin']); updateStatus(user, user?.status)"
                                        class="btn carelon-secondary-btn">
                                        <span> Remove account operator access</span>
                                      </button>
                                    }
                                    <button (click)="checkForProviderAdmin(user)" style="margin-left:20px;" class="btn carelon-secondary-btn">Deactivate</button>
                                    <button (click)="updateLockedPasswordPopup(user)" style="margin-left:20px;" class="btn btn-primary carelon-primary-btn">Reset
                                    user password</button>
                                    <button (click)="linkSitesPop(user)" style="margin-left:20px;" class="btn btn-primary carelon-primary-btn">Add/Remove
                                    Sites</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </tab>
                  <tab heading="Inactive Users" (click)="checkTab='inActiveUser'">

                    @if (inactiveUsers?.length) {
                      <div class="accordion" id="accordionInactiveUser">
                        @for (user of inactiveUsers; track user; let i = $index) {
                          <div class="accordion-item panel-default" >
                            <h2 class="accordion-header" [attr.id]="'heading'+i">
                              <button class="accordion-button collapsed custom-accordion-button" type="button"  data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse'+i" aria-expanded="false" (click)="activeUserOpen(user)" [attr.aria-controls]="'collapse'+i">
                                <span>{{user?.name}} ({{user?.userId}})</span>
                              </button>
                            </h2>
                            <div [attr.id]="'collapse'+i" class="accordion-collapse collapse" [attr.aria-labelledby]="'heading'+i" data-bs-parent="#accordionInactiveUser">
                              <div class="accordion-body">
                                <div class="row textFont">
                                  <div class="col-md-2 col-xs-6">
                                    <b>User Name:</b>
                                  </div>
                                  <div class="col-md-2 col-xs-6">
                                    {{user?.userName}}
                                  </div>
                                  <div class="col-md-2 col-xs-6">
                                    <b>NPI: </b>
                                  </div>
                                  <div class="col-md-2 col-xs-6">
                                    {{ (!user?.npi || user?.npi === '' || user?.npi === 'null') ? '-' : [user?.npi]}}
                                  </div>
                                  <div class="col-md-2 col-xs-6">
                                    <b> Tax ID: </b>
                                  </div>
                                  <div class="col-md-2 col-xs-6">
                                    {{ (!user?.taxId || user?.taxId === '' || user?.taxId === 'null') ? '-' : [user?.taxId]}}
                                  </div>
                                  <div class="col-md-2 col-xs-6">
                                    <b>Phone: </b>
                                  </div>
                                  <div class="col-md-2 col-xs-6">
                                    {{user?.phone}}
                                  </div>
                                  <div class="col-md-2 col-xs-6">
                                    <b>Ext.: </b>
                                  </div>
                                  <div class="col-md-2 col-xs-6">
                                    {{ (!user?.extn || user?.extn === '' || user?.extn === 'null') ? '-' : [user?.extn]}}
                                  </div>
                                  <div class="col-md-2 col-xs-6">
                                    <b>Fax:</b>
                                  </div>
                                  <div class="col-md-2 col-xs-6">
                                    {{ (!user?.fax || user?.fax === '' || user?.fax === 'null') ? '-' : [user?.fax]}}
                                  </div>
                                  <div class="col-md-2 col-xs-6">
                                    <b> User Type: </b>
                                  </div>
                                  <div class="col-md-10 col-xs-6">
                                    {{user?.regTypeDesc}}
                                  </div>
                                  <div class="col-md-2 col-xs-6">
                                    <b>Email:</b>
                                  </div>
                                  <div class="col-md-10 col-xs-6">
                                    {{ (!user?.email || user?.email === 'none@null.com' || user?.email === 'null') ? '-' :
                                    [user?.email]}}
                                  </div>
                                  <div class="col-md-2 col-xs-6">
                                    <b>Address:</b>
                                  </div>
                                  <div class="col-md-6 col-xs-6">
                                    {{user?.addressLine1}} {{user?.addressLine2}} {{user?.city}} {{user?.state}} {{user?.zip}}
                                  </div>
                                </div>
                                <br>
                                  <div class="form-check" style="padding-left: 0px;">
                                    <input type="checkbox" style="padding: 0px;" class="form-check-input" id="exampleCheck1" [(ngModel)]="user.isAdmin">
                                    <label class="form-check-label" for="exampleCheck1">Give account operator access</label>
                                  </div>
                                  <br>
                                    <div class="row">
                                      <div class="col-md-12 text-center btn-block">
                                        <button (click)="updateStatus(user, '1')" class="btn btn-primary carelon-primary-btn">Activate</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </tab>
                      <tab heading="Pending Users" (click)="checkTab='pendingUser'">
                        @if (unregisterdUsers !== undefined) {
                          <div class="accordion" id="accordionunregisterdUsers" >
                            @for (user of unregisterdUsers | sort :'firstName'; track user; let i = $index) {
                              <div class="accordion-item panel-default" >
                                <h2 class="accordion-header" [attr.id]="'heading'+i">
                                  <button class="accordion-button collapsed custom-accordion-button" type="button"  data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse'+i" aria-expanded="false" [attr.aria-controls]="'collapse'+i">
                                    <span>{{user?.firstName}} {{user.middleName}} {{user.lastName}}</span>
                                  </button>
                                </h2>
                                <div [attr.id]="'collapse'+i" class="accordion-collapse collapse" [attr.aria-labelledby]="'heading'+i" data-bs-parent="#accordionunregisterdUsers">
                                  <div class="accordion-body">
                                    <div class="row textFont">
                                      <div class="col-md-2 col-xs-6">
                                        <b>Full Name:</b>
                                      </div>
                                      <div class="col-md-10 col-xs-6">
                                        <p>{{user.firstName}} {{user.middleName}} {{user.lastName}}</p>
                                      </div>
                                      <div class="col-md-2 col-xs-6">
                                        <b>Email:</b>
                                      </div>
                                      <div class="col-md-10 col-xs-6">
                                        {{ (!user.email || user.email === 'none@null.com' || user.email === 'null') ? '-' :
                                        [user.email]}}
                                      </div>
                                      <div class="col-md-2 col-xs-6">
                                        <b>Address:</b>
                                      </div>
                                      <div class="col-md-10 col-xs-6">
                                        {{user.addressLine1}} {{user.addressLine2}} {{user.city}} {{user.state}} {{user.zip}}
                                      </div>
                                      <div class="col-md-2 col-xs-6">
                                        <b>NPI: </b>
                                      </div>
                                      <div class="col-md-2 col-xs-6">
                                        {{ (!user.npi || user.npi === '' || user.npi === 'null') ? '-' : [user.npi]}}
                                      </div>
                                      <div class="col-md-2 col-xs-6">
                                        <b> Tax ID: </b>
                                      </div>
                                      <div class="col-md-2 col-xs-6">
                                        {{ (!user.taxId || user.taxId === '' || user.taxId === 'null') ? '-' : [user.taxId]}}
                                      </div>
                                      <div class="col-md-2 col-xs-6">
                                        <b>Phone: </b>
                                      </div>
                                      <div class="col-md-2 col-xs-6">
                                        {{user.phone}}
                                      </div>
                                      <br>
                                      </div>
                                      <br>
                                        <br>
                                          <div class="row">
                                            <div class="col-md-12 text-center btn-block">
                                              <button (click)="updateAssociateURData(user)" class="btn btn-primary carelon-primary-btn">Resend
                                              Registration </button>
                                              <span   (click)="deleteMessagePopup(user)" style="cursor: pointer;">
                                                <img class="deleteIcon" src="../../assets/images/icons/deleteIcon.svg" alt="Del Icon">
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                              }
                            </tab>

                          </tabset>
                        </div>
                      </div>
                      <div class="modal fade" id="adminUsersModal" role="dialog">
                        <div class="modal-dialog" style="margin-top: 10%;">
                          <div class="modal-content">
                            <div class="modal-header headerFont">
                              <p>You are deactivating the primary account operator, designated by health plan. please choose from below
                              a new primary account operator.</p>
                            </div>
                            <div class="modal-body listUsers">
                              <ul class="list-group">
                                @for (user of adminUsers; track user) {
                                  <div>
                                    @if (user.userName !== currentProviderUser.userName) {
                                      <li class="list-group-item">
                                        <div class="row">
                                          <div class="col-md-6">
                                            {{user.userName}}
                                          </div>
                                          <div class="col-md-6">
                                            <div class="col-md-4">
                                              <button (click)="updateProviderAdmin(user)" class="btn btn-primary textFont">Make As Account
                                              operator</button>
                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                    }
                                  </div>
                                }

                              </ul>
                            </div>
                            <div class="modal-footer">
                              <div class="container-contact100-form-btn">
                                <button type="button" class="btn btn-primary textFont" data-bs-dismiss="modal">Close</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="modal fade" id="delete-dialog" role="dialog">
                          <div class="modal-dialog" style="margin-top: 15%;">
                            <div class="modal-content">
                              <div class="modal-header deleteHeader">
                                <!-- <button type="button"  class="close" data-dismiss="modal">&times;</button> -->
                                <b> Confirm Deletion </b>
                              </div>
                              <div class="modal-body deleteBody">
                                <span>Do you really want to delete this
                                user?</span>
                              </div>
                              <div class="modal-footer justify-content-center">
                                <button type="button"
                                  class="btn btn-primary buttonInfo buttonWidth"
                                (click)="deletePendingUsers()">Yes</button>
                                <button type="button"
                                  class="btn btn-secondary button-sections buttonWidth"
                                  (click)="deleteMessagePopupEnable=false"
                                data-bs-dismiss="modal">No</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="modal fade" id="changePasswordModal" role="dialog">
                        <div class="modal-dialog modal-lg" style="margin-top: 10%">
                          <div class="modal-content">
                            <div class="modal-header">
                              <p>To reset a password use the below form.</p>
                            </div>
                            <div class="modal-body textFont">
                              <div class="form-group">
                                <p style="text-align: left">User Name</p>
                                <input [(ngModel)]="selectedUserForCredReset" name="userForPwdReset" readonly type="text" placeholder="User Name" />

                                <p style="text-align: left">Password</p>
                                <input [(ngModel)]="lockedUserNewPassword" minlength="8" maxlength="15" (keypress)="passRestrict($event)"
                                  type="text" name="userNewPassword" placeholder="Enter Temporary Password" />
                                </div>
                                <div class="col-md-12 text-right">
                                  <button type="button" data-bs-dismiss="modal" style="font-family: Myriad Pro; color: #23499E" class="btn btn-link">Cancel</button>
                                  <!-- <button type="button" class="btn btn-cancel" data-dismiss="modal">Cancel</button> -->
                                  <button type="submit" class="bouton-contact" (click)="updateLockedPassword()">Submit</button>
                                </div>
                                <div class="row col-md-12  passwordMessage">
                                  <b class="note">Password Requirements:</b>
                                  <ul class="circle">
                                    <li style="list-style-type: disc !important;">  Password length must be between 8 and 15 characters.</li>
                                    <li style="list-style-type: disc !important;">  You cannot reuse any of your last 10 passwords. </li>
                                    <li style="list-style-type: disc !important;"> Passwords are case-sensitive and must include at least one lowercase letter (a-z), one uppercase letter (A-Z),  one number (0-9) and one special character ($, !, &#64;, *, ?, |). </li>
                                    <li style="list-style-type: disc !important;">  Blank spaces, the username as the password, and repeating characters or numbers more than twice in a row are not allowed.</li>

                                  </ul>

                                </div>
                              </div>
                              <div class="modal-footer">
                                <div class="form-group">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="modal fade" id="sentEmailModal" role="dialog">
                          <div class="modal-dialog" style="margin-top: 10%;">
                            <div class="modal-content">
                              <div class="modal-header">
                                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                              </div>
                              <div class="modal-body textFont" style=" text-align: center;">
                                <p>{{message}}</p>
                              </div>
                              <div class="modal-footer justify-content-center">
                                <div class="container-contact100-form-btn">
                                  <button type="button" class="btn btn-primary textFont" data-bs-dismiss="modal">Close</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="modal fade" id="dontDeactivateModal" role="dialog">
                          <div class="modal-dialog" style="margin-top: 10%;">
                            <div class="modal-content">
                              <div class="modal-header">
                                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                              </div>
                              <div class="modal-body textFont" style=" text-align: center;">
                                <p>The staff member belongs to other provider sites and therefore you will not be able to deactivate the user. Please use Add/ remove sites to manage sites for which you are designated as Account operator. </p>
                              </div>
                              <div class="modal-footer justify-content-center">
                                <div class="container-contact100-form-btn">
                                  <button type="button" class="btn btn-primary textFont" data-bs-dismiss="modal">Close</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="modal fade siteLinksForUser" id="linkSiteModal" role="dialog">
                          <div class="modal-dialog" style="margin-top: 6%;">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h3 >Site Links for {{selected.userName}}</h3>

                                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>

                              </div>
                              <div class="updateNotifications">

                                @if (updateMessage !== '') {
                                  <div >
                                    <p class=" updateMessage text-success"> {{updateMessage}}</p>
                                  </div>
                                }
                                @if (failureMessage !== '') {
                                  <div >
                                    <p class="failureMessage text-danger"> {{failureMessage}}</p>
                                  </div>
                                }
                              </div>
                              <div class="modal-body textFont auth-modal-body">
                                <div class="col-md-12">
                                </div>
                                @if (selectedUserSites?.length>0) {
                                  <div style=" padding-left: 1rem;">
                                    <h4>Linked Sites</h4>
                                  </div>
                                  <br>
                                    @for (sites of selectedUserSites; track sites) {
                                      <ul class="list-group">
                                        <a class="list-group-item list-group-item-action listStyle text-left">
                                          <div class="row">
                                            <div class="col-md-11 col-xs-8">
                                              {{sites.siteName}}
                                            </div>
                                            @if (sites.ownSite) {
                                              <div class="col-md-1 col-xs-4">
                                                <i class="bi bi-dash-circle text-danger" (click)=removeSites(sites)  style="color: red; cursor: pointer;">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"/>
                                                  </svg>
                                                </i>
                                              </div>
                                            }
                                          </div>
                                        </a>
                                      </ul>
                                    }
                                  }
                                  @if (selectedUserSites?.length ===0) {
                                    <p>No Sites Associated to the user <b>{{selected.userName}}</b></p>
                                  }
                                  @if (actualFilteredUserSites.length > 0) {
                                    <hr />
                                    @if (selectedUserSites) {
                                      <div style=" padding-left: 1rem;">
                                        <h4>Available Sites</h4>
                                      </div>
                                    }
                                    <br>
                                      @for (sites of actualFilteredUserSites; track sites) {
                                        <ul class="list-group">
                                          <a class="list-group-item list-group-item-action listStyle">
                                            <div class="row">
                                              <div class="col-md-11 col-xs-8">
                                                {{sites.siteName}}
                                              </div>
                                              <div class="col-md-1 col-xs-4">
                                                <i class="bi bi-plus-circle text-success" (click)="addSites(sites)"  style="color: green; cursor: pointer;">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                                                  </svg>
                                                </i>
                                              </div>
                                            </div>
                                          </a>
                                        </ul>
                                      }
                                    }
                                  </div>
                                  <div class="modal-footer justify-content-center">
                                    <div class="container-contact100-form-btn">
                                      <button type="button" class="btn btn-primary buttonFont" data-bs-dismiss="modal" (click)="selectionReset()">Cancel</button>
                                      @if (actualFilteredUserSites?.length>0||selectedUserSites!=null) {
                                        <button (click)="postSites()" type="button" class="btn btn-primary buttonFont">Submit</button>
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-1 col-xs-2">
                            </div>
                          </div>
                        </div>
                        <br><br><br><br><br>
                        <app-footer ></app-footer>
                      </div>